import api from '@/api';
import useMeQuery from '@/api/queries/me/useMeQuery';
import { afCovers } from '@/config/constants';
import { useMutation } from '@tanstack/vue-query';
import { AxiosError } from 'axios';
import type { Ref } from 'vue';
import { computed } from 'vue';

export const postCover = async (formData: FormData, uuid?: string) => {
  if (!uuid) throw new AxiosError('UUID is mandatory to change cover');

  const res = await api({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    url: `/user/${uuid}/cover`,
    data: formData,
  });

  return res;
};

export function useCoverMutation(cover?: Ref<Blob | string | undefined>) {
  const { auth } = useMeQuery();

  const data = computed(() => {
    const dataValue = cover?.value ? cover.value : afCovers[0];
    const formData = new FormData();

    formData.append('cover', dataValue);

    return formData;
  });

  const { mutateAsync: updateCover } = useMutation({
    mutationFn: () => postCover(data.value, auth.value?.uuid),
  });

  return { updateCover };
}
